"use client";

import { CircleArrowLeft } from "lucide-react";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export default function NavigationButton() {
  const pathname = usePathname();
  const router = useRouter();
  const [viewed, setViewed] = useState<string[]>([]);

  useEffect(() => {
    setViewed((prev) => [...prev, pathname]);
  }, [pathname]);

  const handleBack = () => {
    setViewed((prev) => prev.slice(0, -2));
    router.back();
  };

  return (
    viewed.length > 1 && (
      <button onClick={handleBack}>
        <CircleArrowLeft />
      </button>
    )
  );
}
